import FalconCloseButton from '@/components/common/FalconCloseButton';
import { Formik } from 'formik';
import React, { useState } from 'react';
import { Modal } from '@/components/common/AppModal';
import { Button, Form, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import gscApi, {
  useGetAuthUrlMutation
} from '@/app/KeywordResearch/api/gscApi';
import type {
  GetAuthUrlErrorData,
  GetAuthUrlMutationError
} from '@/app/KeywordResearch/types/gscApiTypes';
import { errorMessage } from '@/utils/toast';
import { object, string } from 'yup';


const errorMessageText = 'در دریافت لینک اتصال به Google Search Console خطایی رخ داد.'

const getAuthUrlErrorMessage = (error: unknown): string => {
  const err = error as GetAuthUrlMutationError;

  return (
    err?.data?.data?.msg ||
    err?.data?.msg || errorMessageText
  );
};

type ConnectionNameModalProps = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

type ConnectionNameFormValues = {
  account: string;
};

function ConnectionNameModal({ show, setShow }: ConnectionNameModalProps) {
  const [redirected, setRedirected] = useState(false);
  const [getAuthUrl, { isLoading, reset }] = useGetAuthUrlMutation();
  const dispatch = useDispatch();

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      backdrop="static"
      keyboard={false}
    >
      {!redirected && (
        <Formik<ConnectionNameFormValues>
          initialValues={{
            account: ''
          }}
          validationSchema={object().shape({
            account: string()
              .required('وارد کردن کلمه الزامی میباشد')
              .max(50, 'نام اکانت حداکثر میتونه 50 کاراکتر باشه')
          })}
          onSubmit={async values => {
            try {
              const data = await getAuthUrl({
                redirect_uri: window.location.href,
                account_title: values.account
              }).unwrap();

              if (data.code === 200) {
                const { authorize_url, state } = data.data;
                if (authorize_url && state) {
                  localStorage.setItem('gsc_state', state);
                  window.open(authorize_url);
                  setRedirected(true);
                  return;
                }

                errorMessage('پاسخ دریافتی از سرویس اتصال ناقص است.');
                reset();
                return;
              }

              const errorData = data.data as unknown as GetAuthUrlErrorData;

              errorMessage(errorData?.msg || data.msg || errorMessageText);
              reset();
            } catch (error) {
              errorMessage(getAuthUrlErrorMessage(error));
              reset();
            }
          }}
        >
          {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header>
                <Modal.Title>نام اتصال به GSC</Modal.Title>
                <FalconCloseButton onClick={() => setShow(false)} />
              </Modal.Header>
              <Modal.Body>
                <div className="fs--1">
                  این نام نمایشی هست و پیشنهاد میشه جیمیلتون رو به عنوان نام
                  نمایشی درج کنید.
                </div>
                <div className="input-group my-2 input-group-md position-relative">
                  <Form.Control
                    required
                    value={values.account}
                    name="account"
                    id="account"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  <div style={{ position: 'absolute', bottom: '-30px' }}>
                    {errors.account ? (
                      <Form.Label className="text-danger">
                        {errors.account}
                      </Form.Label>
                    ) : null}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShow(false)}>
                  لغو
                </Button>
                <Button variant="falcon-primary" type="submit">
                  {!isLoading ? (
                    <span className="ms-1">اتصال به GSC</span>
                  ) : (
                    <>
                      <Spinner
                        style={{
                          width: '16px',
                          height: '16px'
                        }}
                      />
                      درحال دریافت
                    </>
                  )}
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      )}
    </Modal>
  );
}

export default ConnectionNameModal;
